import { render, staticRenderFns } from "./legal-document-wizard.vue?vue&type=template&id=083ec556&scoped=true"
import script from "./legal-document-wizard.vue?vue&type=script&lang=js"
export * from "./legal-document-wizard.vue?vue&type=script&lang=js"
import style0 from "./legal-document-wizard.vue?vue&type=style&index=0&id=083ec556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083ec556",
  null
  
)

export default component.exports